exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".associated{width:460px;background:#fff;margin:100px auto 0;border-radius:8px}.associated .form-pra{display:-webkit-box;display:-ms-flexbox;display:flex;margin-bottom:24px}.associated .form-pra .form-pra-right{width:400px;border-bottom:1px solid #e1e1e1;padding-bottom:10px;margin-left:10px}.associated .form-pra .border-no{border:0}.associated .sendBtn{width:200px;margin-left:130px}", ""]);

// exports
